/**
 * DiskIcon/index.js
 * desc: disk icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DiskIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="disk icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.disk.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M14 0H2a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V4l-4-4zM9 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM2 6h10V2H2v4z" /></svg>
    </IconButton>
);


export default DiskIcon;
